module.exports = __webpack_public_path__ + "img/logo.b06ba671.png";